import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export type MobileRow = {
  key: string
  leading?: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  trailing?: ReactNode
  meta?: ReactNode
  selected?: boolean
  onClick?: () => void
}

export function MobileList({ rows, className }: { rows: MobileRow[]; className?: string }) {
  return (
    <ul className={cn('divide-y divide-border/70 md:hidden', className)}>
      {rows.map((r) => {
        const body = (
          <>
            {r.leading ? <span className="shrink-0">{r.leading}</span> : null}
            <div className="min-w-0 flex-1 space-y-1.5">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="truncate text-sm font-semibold">{r.title}</div>
                  {r.subtitle ? <div className="truncate text-xs text-muted-foreground">{r.subtitle}</div> : null}
                </div>
                {r.trailing ? <div className="shrink-0 whitespace-nowrap text-right">{r.trailing}</div> : null}
              </div>
              {r.meta ? <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">{r.meta}</div> : null}
            </div>
          </>
        )
        const cls = cn('flex w-full items-start gap-3 px-2 py-3.5 text-left', r.selected && 'bg-primary/5')
        return (
          <li key={r.key}>
            {r.onClick ? (
              <button type="button" className={cn(cls, 'transition-colors hover:bg-muted/40')} onClick={r.onClick}>
                {body}
              </button>
            ) : (
              <div className={cls}>{body}</div>
            )}
          </li>
        )
      })}
    </ul>
  )
}
